import { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';
import IcXCircle from '../../assets/images/svg/ic-x-circle.svg';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    minWidth: 180,
    width: '100%',
    height: 44,
    fontSize: 15,
    lineHeight: '21px',
    padding: '0 36px 0 16px',
    borderRadius: 22,
    border: `solid 1px ${color.$10}`,
    backgroundColor: color.$7,
  },
  'root--focus': {
    borderColor: color.$1,
  },
  input: {
    width: '100%',
    height: '100%',
    border: 'none',
    outline: 'none',
  },
  deleteIcon: {
    cursor: 'pointer',
    position: 'absolute',
    top: 10,
    right: 8,
    '& > img': {
      dispaly: 'block',
    },
  },
}));

function TextFieldCardURL({ inputRef, goodsURL, onChange }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [isFocus, setIsFocus] = useState(false);
  const [localValue, setLocalVelue] = useState(goodsURL);

  function handleChange(e) {
    const v = e.target.value;
    setLocalVelue(v);
    onChange(v);
  }

  function handleClear() {
    setLocalVelue('');
    onChange('');
  }

  return (
    <div
      className={classnames(classes.root, {
        [classes['root--focus']]: isFocus,
      })}
    >
      <input
        ref={inputRef}
        className={classes.input}
        type="text"
        placeholder={t('templates.placeholder-goods-url')}
        value={localValue}
        onChange={handleChange}
        onFocus={() => setIsFocus(true)}
        onBlur={() => setIsFocus(false)}
      />
      {localValue && localValue !== '' && (
        <div className={classes.deleteIcon} onClick={handleClear}>
          <img src={IcXCircle} alt="clear" />
        </div>
      )}
    </div>
  );
}

TextFieldCardURL.defaultProps = {
  inputRef: () => {},
  goodsURL: '',
  onChange: () => {},
};

TextFieldCardURL.propTypes = {
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object }),
  ]),
  goodsURL: PropTypes.string,
  onChange: PropTypes.func,
};

export default TextFieldCardURL;
